import { looksLikeHtml } from "@hightouch/lib/ad-studio/html-editor/looks-like-html";
import { captureSvgAsImage } from "src/pages/ad-studio/layers/utils/capture-svg-preview";
import { captureHtmlAsImage } from "./capture-html-preview";
import { captureHostedFontContent } from "src/pages/ad-studio/html-ad-editor/capture-hosted-font-content";
import { hostedFontStylesheetUrls } from "src/pages/ad-studio/html-ad-editor/hosted-font-stylesheet-urls";

/**
 * Rasterize a saved ad's `svg` column to a PNG `Blob`. Static ads now write
 * HTML into the column; legacy / motion paths still write SVG. `looksLikeHtml`
 * picks the right rasterizer.
 */
export function captureContent(args: {
  content: string;
  fontRules: string[];
  componentAssets: Record<string, string> | null;
  apiBase: string;
  assetId?: string;
}): Promise<Blob> {
  const { content, fontRules, componentAssets, apiBase } = args;
  const stylesheetUrls = hostedFontStylesheetUrls(fontRules);
  if (stylesheetUrls.length > 0) {
    if (!args.assetId) {
      return Promise.reject(
        new Error("Save the ad before exporting Adobe Fonts."),
      );
    }
    return captureHostedFontContent({
      ...args,
      assetId: args.assetId,
      stylesheetUrls,
    });
  }
  return looksLikeHtml(content)
    ? captureHtmlAsImage({
        htmlString: content,
        fontRules,
        apiBase,
        componentAssets,
      })
    : captureSvgAsImage({
        svgString: content,
        fontRules,
        componentAssets,
        apiBase,
      });
}
